import React from "react";
import { Button, Message } from "../BP2Components";

import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { addCartItem } from "../../appRedux/actions/Cart";
import { postCart } from "../../services/restAPI/RestApi";
import { fixedHTML } from "../AdvertisementItem/utils";
import { getCartId } from "../Widgets/DefaultWidgets/ShoppingBasketCardsWidget";

import MainTitleItem from "../AdvertisementItem/subComponents/MainTitleItem/MainTitleItem";
import SubKeyInfoItem from "../AdvertisementItem/subComponents/SubKeyInfoItem/SubKeyInfoItem";

import "./pricingProductItem.less";
import { Icon_ShoppingCart } from "../BP2Components/Icons/icons";

const PricingProductItem = ({
   columns,
   rows,
   item,
   mainTitle,
   shopName,
   showButtonAddToCart,
   showMainTitleLabel,
}) => {
   const dispatch = useDispatch();
   const user = useSelector(({ user }) => user);
   const intl = useIntl();
   const ItemDescription = SubKeyInfoItem;

   const addToCart = () => {
      if (user?.carts?.length && !localStorage.getItem("isPublicUserLogged")) {
         const cartId = getCartId(user, shopName);
         const itemId = item?.item_id ? item?.item_id : item?.item_id?.id;

         postCart(shopName, cartId, itemId, 1, "addItem")
            .then(() => {
               dispatch(addCartItem(shopName, item));
               Message.success(intl.formatMessage({ id: "shopping.basket.addedToCart" }));
            })
            .catch(() =>
               Message.error(intl.formatMessage({ id: "shopping.basket.somethingWrong" })),
            );
      } else {
         dispatch(addCartItem(shopName, item));
         Message.success(intl.formatMessage({ id: "shopping.basket.addedToCart" }));
      }
   };

   const isSelectedColValid = (elem) => {
      if (columns.find((col) => col.title === elem) || elem === "-") return elem;
      else return "-";
   };

   const getTitleFromTechName = (techName) => {
      return columns.find((column) =>
         column.techName !== undefined ? column.techName === techName : false,
      )?.title;
   };

   mainTitle = isSelectedColValid(getTitleFromTechName(mainTitle));

   return (
      <div className="gx-package">
         <div className="gx-package-header gx-text-black">
            <MainTitleItem
               showTitle={showMainTitleLabel}
               value={(mainTitle !== "-" || mainTitle === null) && fixedHTML(rows?.[mainTitle])}
               title={mainTitle}
            />
         </div>

         <div className="gx-package-body">
            <div className="gx-product-container product-item-body">
               {columns
                  .filter(
                     (item) =>
                        item?.title !== mainTitle &&
                        !item?.title.includes("api_") &&
                        !item?.title.includes("[u]") &&
                        rows?.[item?.title],
                  )
                  .map((item, index) => (
                     <ItemDescription
                        key={index}
                        showTitle={true}
                        value={fixedHTML(rows?.[item?.title])}
                        title={item?.title}
                     />
                  ))}
            </div>
            <div
               className="gx-package-footer product-item-footer"
               style={{
                  margin: "auto auto 0 auto",
                  padding: "0 !important",
               }}
            >
               {showButtonAddToCart !== false && (
                  <Button
                     buttonType="primary"
                     className="gx-btn-primary add-to-cart-button"
                     onClick={addToCart}
                  >
                     <Icon_ShoppingCart /> <IntlMessages id="productItem.addToCart" />
                  </Button>
               )}
            </div>
         </div>
      </div>
   );
};

export default PricingProductItem;
